module.exports = __webpack_public_path__ + "img/medidas_doble_v_vf.e4918b81.png";